import { ILangOptions, ILangParams, ILangPath } from "./langProvider.t";
import { createSelector } from "reselect";
import { getAppLangSelector } from "../../app/appSelectors";
import getLangPath from "./utils/getLangPath";

export const makeSelectLangPath = (path: ILangPath = '', params: ILangParams = {}, options: ILangOptions = {}) => createSelector(
    [getAppLangSelector], (lang) => {
        return getLangPath(lang, path, params, options);
    }
);
